module.exports = __webpack_public_path__ + "media/images/favicons/114x114-b8241de3fbc69d07b78b8bd8256cc2d8.png";